// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3-0wp","footer":"Form_footer__31B39"};